/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControl,
  Paper,
  Snackbar,
  Alert,
  InputLabel,
  Chip,
} from '@mui/material';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import PetsIcon from '@mui/icons-material/Pets';
import { Header } from 'components/home';
import { ContainerForm } from 'components/shared/container_form';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { ROUTES } from 'routes/constants';
import { useCuffaStore } from 'stores/cuffa/cuffa.store';
import { CuffaAPI } from 'api/cuffa/cuffa.api';
import TextFieldDataCustom from 'components/shared/textfiel_data_custom';
import { formatDateToDisplay, normalizeIso } from 'utils/date_utils';
import { NumericFormat } from 'react-number-format';


// --- ENUMS E INTERFACES ---
export enum CuffaSanitaryAgencyEnum {
  SECRETARIA_SAUDE_MUNICIPIO = 'SECRETARIA DE SAÚDE DO MUNICÍPIO',
  SECRETARIA_SAUDE_ESTADO = 'SECRETARIA DE SAÚDE DO ESTADO',
}

export enum CuffaInspectionSealEnum {
  SERVICO_INSPECAO_MUNICIPAL_SIM = 'SERVIÇO DE INSPEÇÃO MUNICIPAL – SIM',
  SERVICO_INSPECAO_ESTADUAL_SISE = 'SERVIÇO DE INSPEÇÃO ESTADUAL – SISE',
  SERVICO_INSPECAO_FEDERAL_SIF = 'SERVIÇO DE INSPEÇÃO FEDERAL – SIF',
  SISTEMA_BRASILEIRO_INSPECAO_SISBI = 'SISTEMA BRASILEIRO DE INSPEÇÃO DE PRODUTOS DE ORIGEM ANIMAL – SISBI',
  SISTEMA_ESTADUAL_SUSAF_MT = 'SISTEMA ESTADUAL UNIFICADO DE SANIDADE AGROINDUSTRIAL FAMILIAR – SUSAF MT',
  SERVICO_INSPECAO_PEQUENO_PORTE_SIAPP = 'SERVIÇO DE INSPEÇÃO AGROINDUSTRIAL DE PEQUENO PORTE – SIAPP',
}

export interface ICuffaUpdateLicensesAndInspectionsDto {
  has_vegetal_licenses: boolean;
  has_animal_inspections: boolean;
  vegetal_licenses: {
    license_number: string;
    issuing_body: string;
    emission_date: string;
  }[];
  animal_inspections: {
    seal_type: string;
    registration_number: string;
    emission_date: string;
  }[];
}

// --- CONSTANTES DERIVADAS DOS ENUMS ---
const orgaosEmissoresOptions = Object.values(CuffaSanitaryAgencyEnum);

const selosDeInspecaoOptions = Object.values(CuffaInspectionSealEnum).map(label => ({
  value: label,
  label: label,
}));

// Unidades de medida iguais ao CICAAF
export enum EUnidadeMedida {
  KG = 'KG',
  TON = 'TON',
  L = 'L',
  UN = 'UN',
  CX = 'CX',
  SC = 'SC',
}
const UNIDADES_MEDIDA = Object.entries(EUnidadeMedida).map(([value, label]) => ({ label, value }));

interface IInspecaoFormValues {
  hasVegetal: boolean;
  hasAnimal: boolean;
  possuiAlvaraSanitario: string;
  numeroRegistroAlvara: string;
  orgaoEmissorAlvara: string;
  dataEmissaoAlvara: string;
  possuiRegistroInspecao: string;
  selosSelecionados: string[];
  [key: string]: any;
}

export const getInitialValues = (): IInspecaoFormValues => {
  let hasVegetal = false;
  let hasAnimal = false;
  try {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('formDataAlvaraCuffa');
      if (saved) {
        const items = JSON.parse(saved);
        if (Array.isArray(items)) {
          hasVegetal = items.some((p: any) => p?.product_origin === 'VEGETAL');
          hasAnimal = items.some((p: any) => p?.product_origin === 'ANIMAL');
        }
      }
    }
  } catch { /* empty */ }
  return {
    hasVegetal,
    hasAnimal,
    possuiAlvaraSanitario: '',
    numeroRegistroAlvara: '',
    orgaoEmissorAlvara: '',
    dataEmissaoAlvara: '',
    possuiRegistroInspecao: '',
    selosSelecionados: [],
    ...selosDeInspecaoOptions.reduce((acc, selo) => {
      acc[`numeroRegistro_${selo.value}`] = '';
      acc[`dataEmissao_${selo.value}`] = '';
      return acc;
    }, {} as { [key: string]: string }),
  };
};

export const validarAntesDeSalvar = (values: IInspecaoFormValues, vegetalData: any[], animalData: any[]) => {
  if (!values.hasVegetal && !values.hasAnimal) {
    return { ok: false, message: 'Selecione pelo menos uma origem de produto para salvar.' };
  }
  if (values.hasVegetal) {
    for (const v of vegetalData) {
      if (!v.commercialized_value || v.commercialized_value <= 0) {
        return { ok: false, message: 'O campo "Valor comercializado no último ano" é obrigatório para produtos vegetais.' };
      }
      if (v.has_sanitary_license) {
        if (!v.license_number || !v.issuing_body || !v.emission_date) {
          return { ok: false, message: 'Para produtos vegetais com alvará: Número, Órgão emissor e Data são obrigatórios.' };
        }
      }
    }
  }
  if (values.hasAnimal) {
    for (const a of animalData) {
      if (!a.commercialized_value || a.commercialized_value <= 0) {
        return { ok: false, message: 'O campo "Valor comercializado no último ano" é obrigatório para produtos animais.' };
      }
      if (a.has_inspection_register) {
        if (!a.inspection_seals || a.inspection_seals.length === 0) {
          return { ok: false, message: 'Para produtos animais com inspeção: informe ao menos um selo.' };
        }
        for (const s of a.inspection_seals) {
          if (!s.inspection_seal || !s.register_number || !s.issue_date) {
            return { ok: false, message: 'Campos de selo (tipo, número, data) são obrigatórios.' };
          }
        }
      }
    }
  }
  return { ok: true };
};

export const montarPayload = (values: IInspecaoFormValues, vegetalData: any[], animalData: any[]): ICuffaUpdateLicensesAndInspectionsDto => {
  const payload: ICuffaUpdateLicensesAndInspectionsDto = {
    has_vegetal_licenses: values.hasVegetal,
    has_animal_inspections: values.hasAnimal,
    vegetal_licenses: [],
    animal_inspections: [],
  };
  if (values.hasVegetal) {
    vegetalData.forEach((v) => {
      if (v.has_sanitary_license) {
        payload.vegetal_licenses.push({
          license_number: v.license_number || '',
          issuing_body: v.issuing_body || '',
          emission_date: v.emission_date || '',
        });
      }
    });
  }
  if (values.hasAnimal) {
    const seals = animalData.flatMap((a) => a.has_inspection_register ? a.inspection_seals : []);
    payload.animal_inspections = seals.map((s) => ({
      seal_type: s.inspection_seal,
      registration_number: s.register_number,
      emission_date: s.issue_date,
    }));
  }
  return payload;
};

const validationSchema = Yup.object().shape({});

export const formatCurrency = (value: number) => {
  return (value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const parseCurrencyValue = (value: string) => Number(value.replace(/\D/g, ''));

export const updateVegetalDataValuePure = (vegData: any[], index: number, numericValue: number) => {
  const updated = [...vegData];
  updated[index] = { ...updated[index], commercialized_value: Number(numericValue) };
  return updated;
};

export const updateAnimalDataValuePure = (aniData: any[], index: number, numericValue: number) => {
  const updated = [...aniData];
  updated[index] = { ...updated[index], commercialized_value: Number(numericValue) };
  return updated;
};

export const removeItemFromLocalStorage = (origin: 'VEGETAL' | 'ANIMAL', productUuid: string) => {
  try {
    const prev = localStorage.getItem('formDataAlvaraCuffa');
    if (!prev) return;
    const items = JSON.parse(prev);
    if (!Array.isArray(items)) return;
    const filtered = items.filter((it: any) => !(it?.product_origin === origin && it?.product_uuid === productUuid));
    localStorage.setItem('formDataAlvaraCuffa', JSON.stringify(filtered));
  } catch (e) {
    console.warn('Falha ao remover item do localStorage', e);
  }
};

export const InspecaoProdutosIncluir: React.FC = () => {
  const navigate = useNavigate();
  const { uuid } = useParams<{ uuid: string }>();
  const { salvarDadosParciais } = useCuffaStore();

  const [initialLoading, setInitialLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const advanceNext = useRef(false);
  const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  // Produtos por origem
  const [availableVegetalProducts, setAvailableVegetalProducts] = useState<Array<{ uuid: string; name: string }>>([]);
  const [availableAnimalProducts, setAvailableAnimalProducts] = useState<Array<{ uuid: string; name: string }>>([]);
  const [selectedVegetalProduct, setSelectedVegetalProduct] = useState<string>('');
  const [selectedAnimalProduct, setSelectedAnimalProduct] = useState<string>('');
  const [chosenVegetalProducts, setChosenVegetalProducts] = useState<string[]>([]);
  const [chosenAnimalProducts, setChosenAnimalProducts] = useState<string[]>([]);
  // Estado por produto (como na tela Cicaaf)
  const [vegetalData, setVegetalData] = useState<Array<{
    product_uuid: string;
    product_name?: string;
    commercialized_value?: number;
    commercialized_volume?: number;
    measurement_unit?: string;
    has_sanitary_license: boolean;
    license_number?: string;
    issuing_body?: string;
    emission_date?: string;
    valorTouched?: boolean;
  }>>([]);
  const [animalData, setAnimalData] = useState<Array<{
    product_uuid: string;
    product_name?: string;
    commercialized_value?: number;
    commercialized_volume?: number;
    measurement_unit?: string;
    has_inspection_register: boolean;
    inspection_seals: Array<{ inspection_seal: string; register_number: string; issue_date: string }>;
    showSeloForm?: boolean;
    novoSelo?: { inspection_seal: string; register_number: string; issue_date: string };
    dateError?: boolean;
    registerNumberError?: boolean;
    valorTouched?: boolean;
  }>>([]);

  // Garantia extra: se carregarmos dados de produtos (via localStorage ou API),
  // marcamos automaticamente as origens para refletir os cartões verde/vermelho.
  // Evita casos em que os arrays são preenchidos antes de setar os flags do formik.
  useEffect(() => {
    if (vegetalData.length > 0 && !formik.values.hasVegetal) {
      formik.setFieldValue('hasVegetal', true);
    }
    if (animalData.length > 0 && !formik.values.hasAnimal) {
      formik.setFieldValue('hasAnimal', true);
    }
    // Intencionalmente não desmarcamos automaticamente quando arrays ficam vazios,
    // para não conflitar com ações explícitas do usuário.
  }, [vegetalData, animalData]);

  const formik = useFormik<IInspecaoFormValues>({
    initialValues: getInitialValues(),
    validationSchema,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async (values) => {
      if (!uuid) return;
      if (!values.hasVegetal && !values.hasAnimal) {
        setSnackbarMessage('Selecione pelo menos uma origem de produto para salvar.');
        setOpenErrorSnackbar(true);
        return;
      }

      // Validações customizadas alinhadas ao estado por produto
      if (values.hasVegetal) {
        for (let i = 0; i < vegetalData.length; i++) {
          const v = vegetalData[i];
          if (!v.commercialized_value || v.commercialized_value <= 0) {
            const updated = [...vegetalData];
            updated[i] = { ...updated[i], valorTouched: true };
            setVegetalData(updated);
            setSnackbarMessage('O campo "Valor comercializado no último ano" é obrigatório para produtos vegetais.');
            setOpenErrorSnackbar(true);
            return;
          }
          if (v.has_sanitary_license) {
            if (!v.license_number || !v.issuing_body || !v.emission_date) {
              setSnackbarMessage('Para produtos vegetais com alvará: Número, Órgão emissor e Data são obrigatórios.');
              setOpenErrorSnackbar(true);
              return;
            }
          }
        }
      }

      if (values.hasAnimal) {
        for (let i = 0; i < animalData.length; i++) {
          const a = animalData[i];
          if (!a.commercialized_value || a.commercialized_value <= 0) {
            const updated = [...animalData];
            updated[i] = { ...updated[i], valorTouched: true };
            setAnimalData(updated);
            setSnackbarMessage('O campo "Valor comercializado no último ano" é obrigatório para produtos animais.');
            setOpenErrorSnackbar(true);
            return;
          }
          if (a.has_inspection_register) {
            if (!a.inspection_seals || a.inspection_seals.length === 0) {
              setSnackbarMessage('Para produtos animais com inspeção: informe ao menos um selo.');
              setOpenErrorSnackbar(true);
              return;
            }
            for (const s of a.inspection_seals) {
              if (!s.inspection_seal || !s.register_number || !s.issue_date) {
                setSnackbarMessage('Campos de selo (tipo, número, data) são obrigatórios.');
                setOpenErrorSnackbar(true);
                return;
              }
            }
          }
        }
      }

      setSaving(true);
      const payload: ICuffaUpdateLicensesAndInspectionsDto = {
        has_vegetal_licenses: values.hasVegetal,
        has_animal_inspections: values.hasAnimal,
        vegetal_licenses: [],
        animal_inspections: [],
      };

      // Monta licenças vegetais por produto selecionado
      if (values.hasVegetal) {
        vegetalData.forEach(v => {
          if (v.has_sanitary_license) {
            payload.vegetal_licenses.push({
              license_number: v.license_number || '',
              issuing_body: v.issuing_body || '',
              emission_date: v.emission_date || '',
            });
          }
        });
      }

      // Monta inspeções animais por produto selecionado
      if (values.hasAnimal) {
        const seals = animalData.flatMap(a => a.has_inspection_register ? a.inspection_seals : []);
        payload.animal_inspections = seals.map(s => ({
          seal_type: s.inspection_seal,
          registration_number: s.register_number,
          emission_date: s.issue_date,
        }));
      }

      try {
        await CuffaAPI.updateLicensesAndInspections(uuid, payload);
        const proximaRota = ROUTES.SELOS_AGREGACAO_CUFFA_INCLUIR.replace(':uuid', uuid);
        salvarDadosParciais({
          inspecaoProdutos: {
            ...values,
            vegetalData,
            animalData
          },
          ultimaRota: proximaRota
        });
        setSnackbarMessage('Dados salvos com sucesso!');
        setOpenSuccessSnackbar(true);

        if (advanceNext.current) {
          navigate(proximaRota);
        }
      } catch (error: any) {
        setSnackbarMessage(error.message || 'Erro ao salvar os dados. Tente novamente.');
        setOpenErrorSnackbar(true);
      } finally {
        setSaving(false);
        advanceNext.current = false;
      }
    },
  });


  useEffect(() => {
    const fetchInitialData = async () => {
      // Preferir dados do storage Zustand (cuffa-storage > dadosParciais > inspecaoProdutos)
      try {
        const storageKey = `cuffa-storage-${uuid}`;
        const storage = window.localStorage.getItem(storageKey);
        let inspecaoProdutos = null;
        if (storage) {
          try {
            const cuffa = JSON.parse(storage);
            inspecaoProdutos = cuffa?.state?.dadosParciais?.inspecaoProdutos;
          } catch (e) {
            console.warn('Falha ao parsear cuffa-storage do localStorage', e);
          }
        }
        if (inspecaoProdutos) {
          setVegetalData(Array.isArray(inspecaoProdutos.vegetalData) ? inspecaoProdutos.vegetalData : []);
          setAnimalData(Array.isArray(inspecaoProdutos.animalData) ? inspecaoProdutos.animalData : []);
          setChosenVegetalProducts(Array.isArray(inspecaoProdutos.vegetalData) ? inspecaoProdutos.vegetalData.map((v: any) => v.product_uuid) : []);
          setChosenAnimalProducts(Array.isArray(inspecaoProdutos.animalData) ? inspecaoProdutos.animalData.map((a: any) => a.product_uuid) : []);
          formik.setValues({
            ...getInitialValues(),
            ...inspecaoProdutos,
          });
          setInitialLoading(false);
          return;
        }
      } catch (e) {
        console.warn('Falha ao restaurar inspecaoProdutos do cuffa-storage', e);
      }


      if (!uuid) {
        setSnackbarMessage("UUID da coleta não foi encontrado. Por favor, volte ao início.");
        setOpenErrorSnackbar(true);
        setInitialLoading(false);
        return;
      }

      try {
        const response = await CuffaAPI.getDataByID(uuid);
        // << --- AJUSTE AQUI --- >>
        // Acessamos 'response.dados' diretamente, igual ao componente de visualização.
        const savedData = response.dados;

        if (savedData) {
          const newFormValues = { ...getInitialValues() };

          // Preserva marcações vindas de localStorage/estado já definido,
          // evitando desmarcar rapidamente por causa da resposta da API.
          newFormValues.hasVegetal = !!savedData.has_vegetal_licenses || !!(Array.isArray(savedData.vegetal_products) && savedData.vegetal_products.length > 0) || !!formik.values.hasVegetal;
          newFormValues.hasAnimal = !!savedData.has_animal_inspections || !!(Array.isArray(savedData.animal_products) && savedData.animal_products.length > 0) || !!formik.values.hasAnimal;

          if (newFormValues.hasVegetal) {
            if (savedData.vegetal_licenses && savedData.vegetal_licenses.length > 0) {
              newFormValues.possuiAlvaraSanitario = 'sim';
              const licenca = savedData.vegetal_licenses[0];
              newFormValues.numeroRegistroAlvara = licenca.license_number;
              newFormValues.orgaoEmissorAlvara = licenca.issuing_body;
              // Garante que a data não quebre se for inválida
              if (licenca.emission_date) {
                newFormValues.dataEmissaoAlvara = new Date(licenca.emission_date).toISOString().split('T')[0];
              }
            } else {
              newFormValues.possuiAlvaraSanitario = 'nao';
            }
          }

          if (newFormValues.hasAnimal) {
            if (savedData.animal_inspections && savedData.animal_inspections.length > 0) {
              newFormValues.possuiRegistroInspecao = 'sim';
              newFormValues.selosSelecionados = savedData.animal_inspections.map((insp: any) => insp.seal_type);
              savedData.animal_inspections.forEach((insp: any) => {
                newFormValues[`numeroRegistro_${insp.seal_type}`] = insp.registration_number;
                if (insp.emission_date) {
                  newFormValues[`dataEmissao_${insp.seal_type}`] = new Date(insp.emission_date).toISOString().split('T')[0];
                }
              });
            } else {
              newFormValues.possuiRegistroInspecao = 'nao';
            }
          }
          // Primeiro garante flags de origem para evitar flicker visual
          formik.setFieldValue('hasVegetal', newFormValues.hasVegetal);
          formik.setFieldValue('hasAnimal', newFormValues.hasAnimal);
          // Em seguida aplica os demais valores do formulário
          formik.setValues(newFormValues);
          // Preenche estados por produto a partir dos dados salvos (quando possível)
          if (Array.isArray(savedData.vegetal_products)) {
            setChosenVegetalProducts(savedData.vegetal_products.map((p: any) => p.uuid));
            setVegetalData(savedData.vegetal_products.map((p: any) => ({
              product_uuid: p.uuid,
              has_sanitary_license: !!p.has_sanitary_license,
              license_number: p.license_number || '',
              issuing_body: p.issuing_body || '',
              emission_date: p.emission_date || '',
              commercialized_value: p.commercialized_value || 0,
            })));
          } else if (newFormValues.hasVegetal && savedData.vegetal_licenses?.length) {
            // Sem vínculo por produto, usa uma única entrada padrão
            setVegetalData(savedData.vegetal_licenses.map((lic: any, idx: number) => ({
              product_uuid: `vegetal-${idx}`,
              has_sanitary_license: true,
              license_number: lic.license_number,
              issuing_body: lic.issuing_body,
              emission_date: lic.emission_date,
              commercialized_value: 0,
            })));
          }

          if (Array.isArray(savedData.animal_products)) {
            setChosenAnimalProducts(savedData.animal_products.map((p: any) => p.uuid));
            setAnimalData(savedData.animal_products.map((p: any) => ({
              product_uuid: p.uuid,
              has_inspection_register: !!p.has_inspection_register,
              inspection_seals: Array.isArray(p.inspection_seals) ? p.inspection_seals : [],
              showSeloForm: false,
              novoSelo: { inspection_seal: '', register_number: '', issue_date: '' },
              commercialized_value: p.commercialized_value || 0,
            })));
          } else if (newFormValues.hasAnimal && savedData.animal_inspections?.length) {
            setAnimalData([{
              product_uuid: 'animal-0',
              has_inspection_register: true,
              inspection_seals: savedData.animal_inspections.map((insp: any) => ({
                inspection_seal: insp.seal_type,
                register_number: insp.registration_number,
                issue_date: insp.emission_date,
              })),
              showSeloForm: false,
              novoSelo: { inspection_seal: '', register_number: '', issue_date: '' },
              commercialized_value: 0,
            }]);
          }

          // Tentativa adicional de carregar nomes dos produtos caso não tenham sido carregados antes
          try {
            if (chosenVegetalProducts.length > 0 && availableVegetalProducts.length === 0) {
              const vegetalResp = await CuffaAPI.getProducts(['VEGETAL']);
              const vegetalList = Array.isArray(vegetalResp?.dados) ? vegetalResp.dados : (Array.isArray(vegetalResp) ? vegetalResp : []);
              setAvailableVegetalProducts(vegetalList.map((p: any) => ({ uuid: p?.uuid, name: p?.name })));
            }
            if (chosenAnimalProducts.length > 0 && availableAnimalProducts.length === 0) {
              const animalResp = await CuffaAPI.getProducts(['ANIMAL']);
              const animalList = Array.isArray(animalResp?.dados) ? animalResp.dados : (Array.isArray(animalResp) ? animalResp : []);
              setAvailableAnimalProducts(animalList.map((p: any) => ({ uuid: p?.uuid, name: p?.name })));
            }
          } catch (e) {
            // não bloquear o fluxo se falhar
            console.warn('Falha ao carregar listas de produtos após fetch by ID', e);
          }
        }
      } catch (error) {
        console.error("Erro ao buscar dados de inspeção:", error);
        setSnackbarMessage('Erro ao carregar os dados. Tente novamente.');
        setOpenErrorSnackbar(true);
      } finally {
        setInitialLoading(false);
      }
    };
    fetchInitialData();
  }, [uuid]);

  // Carregar lista de produtos por origem quando marcar as origens
  useEffect(() => {
    const loadProductsByOrigin = async () => {
      // Evita conflito durante a fase de inicialização
      if (initialLoading) return;
      try {
        if (formik.values.hasVegetal) {
          const vegetalResp = await CuffaAPI.getProducts(['VEGETAL']);
          const vegetalList = Array.isArray(vegetalResp?.dados) ? vegetalResp.dados : (Array.isArray(vegetalResp) ? vegetalResp : []);
          setAvailableVegetalProducts(
            vegetalList.map((p: any) => ({ uuid: p?.uuid, name: p?.name }))
          );
        } else {
          setAvailableVegetalProducts([]);
          setChosenVegetalProducts([]);
          setSelectedVegetalProduct('');
          setVegetalData([]);
        }

        if (formik.values.hasAnimal) {
          const animalResp = await CuffaAPI.getProducts(['ANIMAL']);
          const animalList = Array.isArray(animalResp?.dados) ? animalResp.dados : (Array.isArray(animalResp) ? animalResp : []);
          setAvailableAnimalProducts(
            animalList.map((p: any) => ({ uuid: p?.uuid, name: p?.name }))
          );
        } else {
          setAvailableAnimalProducts([]);
          setChosenAnimalProducts([]);
          setSelectedAnimalProduct('');
          setAnimalData([]);
        }
      } catch (e) {
        console.error('Erro ao carregar produtos por origem:', e);
      }
    };
    loadProductsByOrigin();
  }, [formik.values.hasVegetal, formik.values.hasAnimal, initialLoading]);

  const handleValorChangeVegetal = (index: number, value: string) => {
    const numericValue = parseCurrencyValue(value);
    const updated = updateVegetalDataValuePure(vegetalData, index, numericValue);
    setVegetalData(updated);
  };

  const handleValorChangeAnimal = (index: number, value: string) => {
    const numericValue = parseCurrencyValue(value);
    const updated = updateAnimalDataValuePure(animalData, index, numericValue);
    setAnimalData(updated);
  };

  const handleCloseSnackbar = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    setOpenSuccessSnackbar(false);
    setOpenErrorSnackbar(false);
  };

  const handleOriginChange = (origin: 'vegetal' | 'animal') => {
    const fieldName = origin === 'vegetal' ? 'hasVegetal' : 'hasAnimal';
    const newValue = !formik.values[fieldName];
    formik.setFieldValue(fieldName, newValue);
    if (!newValue) {
      if (origin === 'vegetal') {
        formik.setFieldValue('possuiAlvaraSanitario', '');
        formik.setFieldValue('numeroRegistroAlvara', '');
        formik.setFieldValue('orgaoEmissorAlvara', '');
        formik.setFieldValue('dataEmissaoAlvara', '');
      } else {
        formik.setFieldValue('possuiRegistroInspecao', '');
        formik.setFieldValue('selosSelecionados', []);
        selosDeInspecaoOptions.forEach(selo => {
          formik.setFieldValue(`numeroRegistro_${selo.value}`, '');
          formik.setFieldValue(`dataEmissao_${selo.value}`, '');
        });
      }
    }
  };

  // Remove item específico do localStorage pelo par origem/uuid (delegates to top-level helper)

  const handleSave = () => {
    advanceNext.current = false;
    if (!uuid) return;
    const payload = {
      inspecaoProdutos: {
        ...formik.values,
        vegetalData,
        animalData
      },
      ultimaRota: ROUTES.SELOS_AGREGACAO_CUFFA_INCLUIR.replace(':uuid', uuid)
    };
    salvarDadosParciais(payload);
    try {
      const storageKey = `cuffa-storage-${uuid}`;
      localStorage.setItem(storageKey, JSON.stringify({ state: { dadosParciais: payload } }));
    } catch (e) {
      console.warn('Falha ao salvar cuffa-storage no localStorage', e);
    }
    formik.handleSubmit();
  };

  const handleAdvance = () => {
    advanceNext.current = true;
    if (!uuid) return;
    const payload = {
      inspecaoProdutos: {
        ...formik.values,
        vegetalData,
        animalData
      },
      ultimaRota: ROUTES.SELOS_AGREGACAO_CUFFA_INCLUIR.replace(':uuid', uuid)
    };
    salvarDadosParciais(payload);
    try {
      const storageKey = `cuffa-storage-${uuid}`;
      localStorage.setItem(storageKey, JSON.stringify({ state: { dadosParciais: payload } }));
    } catch (e) {
      console.warn('Falha ao salvar cuffa-storage no localStorage', e);
    }
    formik.handleSubmit();
  };


  if (initialLoading) {
    return (
      <MenuProvider>
        <TopNavBar />
        <Header title="Inspeção de Produtos" showBackButton />
        <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
          <CircularProgress />
          <Typography ml={2}>Carregando dados...</Typography>
        </Box>
      </MenuProvider>
    );
  }

  return (
    <MenuProvider>
      <TopNavBar />
      <Header title="Inspeção de Produtos" showBackButton />
      <Box width="100%" display="flex" justifyContent="center" margin="2rem 0">
        <Box sx={{ maxWidth: '1152px', padding: '2rem', width: '100%' }}>
          <ContainerForm title="Selos de Inspeção" subtitle="Formulário de registro da inspeção conforme origem do produto" width="100%">
            <Paper elevation={0} sx={{ p: 3, mb: 4, border: '2px solid #000', borderRadius: '8px' }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>Origem dos Produtos</Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>Selecione a origem dos produtos da sua unidade familiar para preencher os campos correspondentes.</Typography>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} md={6}>
                  <Paper onClick={() => handleOriginChange('vegetal')} elevation={0} sx={{ p: 2, height: '100%', border: formik.values.hasVegetal ? '2px solid #2e7d32' : '2px solid #ccc', borderRadius: '8px', display: 'flex', alignItems: 'flex-start', cursor: 'pointer', backgroundColor: formik.values.hasVegetal ? 'rgba(76, 175, 80, 0.1)' : 'transparent', transition: 'border-color 0.3s, background-color 0.3s' }}>
                    <Checkbox checked={formik.values.hasVegetal} color="success" sx={{ p: 0, mr: 2 }} />
                    <LocalFloristIcon color={formik.values.hasVegetal ? "success" : "action"} sx={{ fontSize: 32, mr: 1, mt: -0.5 }} />
                    <Box>
                      <Typography variant="h6" fontWeight="bold">Produtos de Origem Vegetal</Typography>
                      <Typography variant="body2" color="text.secondary">Frutas, verduras, grãos e seus derivados.</Typography>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper onClick={() => handleOriginChange('animal')} elevation={0} sx={{ p: 2, height: '100%', border: formik.values.hasAnimal ? '2px solid #d32f2f' : '2px solid #ccc', borderRadius: '8px', display: 'flex', alignItems: 'flex-start', cursor: 'pointer', backgroundColor: formik.values.hasAnimal ? 'rgba(233, 30, 99, 0.1)' : 'transparent', transition: 'border-color 0.3s, background-color 0.3s' }}>
                    <Checkbox checked={formik.values.hasAnimal} color="error" sx={{ p: 0, mr: 2 }} />
                    <PetsIcon color={formik.values.hasAnimal ? "error" : "action"} sx={{ fontSize: 32, mr: 1, mt: -0.5 }} />
                    <Box>
                      <Typography variant="h6" fontWeight="bold">Produtos de Origem Animal</Typography>
                      <Typography variant="body2" color="text.secondary">Carnes, laticínios, ovos, mel e seus derivados.</Typography>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Paper>

            {formik.values.hasVegetal && (
              <Paper elevation={0} sx={{ p: 3, mb: 4, border: '2px solid #000', borderRadius: '8px' }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>Inspeção - Produtos Vegetais</Typography>
                {/* Lista de produtos vegetais */}
                <Box mt={2} mb={2}>
                  <FormControl fullWidth>
                    <InputLabel>Selecione o produto vegetal</InputLabel>
                    <Select
                      label="Selecione o produto vegetal"
                      value={selectedVegetalProduct}
                      onChange={(e) => setSelectedVegetalProduct(e.target.value as string)}
                    >
                      <MenuItem value="">
                        <em>Selecione um produto</em>
                      </MenuItem>
                      {availableVegetalProducts.map((p) => (
                        <MenuItem
                          key={p.uuid}
                          value={p.uuid}
                          disabled={chosenVegetalProducts.includes(p.uuid)}
                        >
                          {p.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Box mt={2} display="flex" gap={1} alignItems="center">
                    <Button
                      variant="outlined"
                      onClick={() => {
                        if (selectedVegetalProduct && !chosenVegetalProducts.includes(selectedVegetalProduct)) {
                          const prod = availableVegetalProducts.find(p => p.uuid === selectedVegetalProduct);
                          setChosenVegetalProducts([...chosenVegetalProducts, selectedVegetalProduct]);
                          setVegetalData([
                            ...vegetalData,
                            {
                              product_uuid: selectedVegetalProduct,
                              product_name: prod?.name ?? '',
                              commercialized_value: 0,
                              commercialized_volume: 0,
                              measurement_unit: 'KG',
                              has_sanitary_license: false,
                              license_number: '',
                              issuing_body: '',
                              emission_date: '',
                            }
                          ]);
                          setSelectedVegetalProduct('');
                        }
                      }}
                      disabled={!selectedVegetalProduct}
                    >
                      Adicionar Produto Vegetal
                    </Button>
                  </Box>
                  {chosenVegetalProducts.length > 0 && (
                    <Box mt={2} display="flex" gap={1} flexWrap="wrap">
                      {chosenVegetalProducts.map((id) => {
                        const prod = availableVegetalProducts.find(p => p.uuid === id);
                        return (
                          <Chip
                            key={id}
                            label={prod?.name ?? id}
                            onDelete={() => {
                              setChosenVegetalProducts(chosenVegetalProducts.filter(p => p !== id));
                              setVegetalData(vegetalData.filter(v => v.product_uuid !== id));
                              removeItemFromLocalStorage('VEGETAL', id);
                            }}
                          />
                        );
                      })}
                    </Box>
                  )}
                </Box>
                {/* Campos de alvará por produto vegetal */}
                {vegetalData.map((v, idx) => {
                  const prod = availableVegetalProducts.find(p => p.uuid === v.product_uuid);
                  return (
                    <Box key={v.product_uuid} mt={3} p={2} border="1px solid #eee" borderRadius={1}>
                      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>{prod?.name ?? `Produto Vegetal ${idx + 1}`}</Typography>
                      <Box mt={3}>
                        <Typography variant="subtitle1" gutterBottom>Valor comercializado no último ano *</Typography>
                        <NumericFormat
                          customInput={TextField}
                          value={(v.commercialized_value ?? 0) / 100}
                          onValueChange={(values) => {
                            const numericValue = Math.round((values.floatValue ?? 0) * 100);
                            const updated = [...vegetalData];
                            updated[idx] = {
                              ...updated[idx],
                              commercialized_value: numericValue,
                              valorTouched: true
                            };
                            setVegetalData(updated);
                          }}
                          onBlur={() => {
                            const updated = [...vegetalData];
                            updated[idx] = { ...updated[idx], valorTouched: true };
                            setVegetalData(updated);
                          }}
                          error={v.valorTouched && (!v.commercialized_value || v.commercialized_value <= 0)}
                          helperText={v.valorTouched && (!v.commercialized_value || v.commercialized_value <= 0) ? 'Campo obrigatório' : ''}
                          thousandSeparator="."
                          decimalSeparator=","
                          prefix="R$ "
                          decimalScale={2}
                          fixedDecimalScale
                          allowNegative={false}
                          fullWidth
                        />
                      </Box>
                      <Box mt={2}>
                        <TextField
                          value={v.commercialized_volume ?? ''}
                          label="Volume comercializado no último ano"
                          onChange={(e) => {
                            const value = e.target.value === '' ? undefined : Number(e.target.value);
                            if (value === undefined || value >= 0) {
                              const updated = [...vegetalData];
                              updated[idx] = { ...updated[idx], commercialized_volume: value };
                              setVegetalData(updated);
                            }
                          }}
                          onInput={(e: any) => {
                            const target = e.target || e.currentTarget;
                            if (!target || typeof target.value !== 'string') return;
                            // Remove non-numeric characters except decimal point
                            target.value = target.value.replace(/[^\d.]/g, '');
                            // Prevent multiple decimal points
                            const decimalCount = (target.value.match(/\./g) || []).length;
                            if (decimalCount > 1) {
                              target.value = target.value.replace(/\.(?=.*\.)/g, '');
                            }
                          }}
                          fullWidth
                          inputProps={{ inputMode: 'decimal' }}
                          sx={{
                            '& input[type=number]::-webkit-outer-spin-button,& input[type=number]::-webkit-inner-spin-button': {
                              WebkitAppearance: 'none',
                              margin: 0,
                            },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          }}
                        />
                      </Box>

                      <Box mt={2}>
                        <TextField
                          select
                          label="Unidade de medida"
                          value={v.measurement_unit ?? 'KG'}
                          onChange={(e) => {
                            const updated = [...vegetalData];
                            updated[idx] = { ...updated[idx], measurement_unit: e.target.value };
                            setVegetalData(updated);
                          }}
                          fullWidth
                        >
                          {UNIDADES_MEDIDA.map((unidade) => (
                            <MenuItem key={unidade.value} value={unidade.value}>
                              {unidade.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Box>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <Typography variant="subtitle1" component="legend" gutterBottom>Possui alvará sanitário? *</Typography>
                        <RadioGroup
                          row
                          value={v.has_sanitary_license ? 'sim' : 'nao'}
                          onChange={(e) => {
                            const has = e.target.value === 'sim';
                            setVegetalData(vegetalData.map(item => item.product_uuid === v.product_uuid ? { ...item, has_sanitary_license: has } : item));
                          }}
                        >
                          <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                          <FormControlLabel value="nao" control={<Radio />} label="Não" />
                        </RadioGroup>
                      </FormControl>
                      {v.has_sanitary_license && (
                        <>
                          <TextField
                            fullWidth
                            label="Número de registro do alvará sanitário *"
                            variant="outlined"
                            margin="normal"
                            value={v.license_number ?? ''}
                            onChange={(e) => setVegetalData(vegetalData.map(item => item.product_uuid === v.product_uuid ? { ...item, license_number: e.target.value } : item))}
                          />
                          <FormControl fullWidth variant="outlined" margin="normal">
                            <InputLabel>Órgão emissor *</InputLabel>
                            <Select
                              label="Órgão emissor *"
                              value={v.issuing_body ?? ''}
                              onChange={(e) => setVegetalData(vegetalData.map(item => item.product_uuid === v.product_uuid ? { ...item, issuing_body: e.target.value as string } : item))}
                            >
                              {orgaosEmissoresOptions.map(orgao => (<MenuItem key={orgao} value={orgao}>{orgao}</MenuItem>))}
                            </Select>
                          </FormControl>
                          <TextField
                            label="Data de emissão *"
                            type="date"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            value={v.emission_date ?? ''}
                            onChange={(e) => setVegetalData(vegetalData.map(item => item.product_uuid === v.product_uuid ? { ...item, emission_date: e.target.value } : item))}
                            InputLabelProps={{ shrink: true }}
                          />
                        </>
                      )}
                    </Box>
                  );
                })}
              </Paper>
            )}

            {formik.values.hasAnimal && (
              <Paper elevation={0} sx={{ p: 3, mb: 4, border: '2px solid #000', borderRadius: '8px' }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>Inspeção - Produtos de Origem Animal</Typography>
                {/* Lista de produtos animais */}
                <Box mt={2} mb={2}>
                  <FormControl fullWidth>
                    <InputLabel>Selecione o produto animal</InputLabel>
                    <Select
                      label="Selecione o produto animal"
                      value={selectedAnimalProduct}
                      onChange={(e) => setSelectedAnimalProduct(e.target.value as string)}
                    >
                      <MenuItem value="">
                        <em>Selecione um produto</em>
                      </MenuItem>
                      {availableAnimalProducts.map((p) => (
                        <MenuItem
                          key={p.uuid}
                          value={p.uuid}
                          disabled={chosenAnimalProducts.includes(p.uuid)}
                        >
                          {p.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Box mt={2} display="flex" gap={1} alignItems="center">
                    <Button
                      variant="outlined"
                      onClick={() => {
                        if (selectedAnimalProduct && !chosenAnimalProducts.includes(selectedAnimalProduct)) {
                          const prod = availableAnimalProducts.find(p => p.uuid === selectedAnimalProduct);
                          setChosenAnimalProducts([...chosenAnimalProducts, selectedAnimalProduct]);
                          setAnimalData([
                            ...animalData,
                            {
                              product_uuid: selectedAnimalProduct,
                              product_name: prod?.name ?? '',
                              commercialized_value: 0,
                              commercialized_volume: 0,
                              measurement_unit: 'KG',
                              has_inspection_register: false,
                              inspection_seals: [],
                              showSeloForm: false,
                              novoSelo: { inspection_seal: '', register_number: '', issue_date: '' },
                            }
                          ]);
                          setSelectedAnimalProduct('');
                        }
                      }}
                      disabled={!selectedAnimalProduct}
                    >
                      Adicionar Produto Animal
                    </Button>
                  </Box>
                  {chosenAnimalProducts.length > 0 && (
                    <Box mt={2} display="flex" gap={1} flexWrap="wrap">
                      {chosenAnimalProducts.map((id) => {
                        const prod = availableAnimalProducts.find(p => p.uuid === id);
                        return (
                          <Chip
                            key={id}
                            label={prod?.name ?? id}
                            onDelete={() => {
                              setChosenAnimalProducts(chosenAnimalProducts.filter(p => p !== id));
                              setAnimalData(animalData.filter(a => a.product_uuid !== id));
                              removeItemFromLocalStorage('ANIMAL', id);
                            }}
                          />
                        );
                      })}
                    </Box>
                  )}
                </Box>
                {/* Campos de inspeção por produto animal */}
                {animalData.map((a, idx) => {
                  const prod = availableAnimalProducts.find(p => p.uuid === a.product_uuid);
                  const novoSelo = a.novoSelo || { inspection_seal: '', register_number: '', issue_date: '' };
                  return (
                    <Box key={a.product_uuid} mt={3} p={2} border="1px solid #eee" borderRadius={1}>
                      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>{prod?.name ?? `Produto Animal ${idx + 1}`}</Typography>
                      <Box mt={3}>
                        <Typography variant="subtitle1" gutterBottom>Valor comercializado no último ano *</Typography>
                        <NumericFormat
                          customInput={TextField}
                          value={(a.commercialized_value ?? 0) / 100}
                          onValueChange={(values) => {
                            const numericValue = Math.round((values.floatValue ?? 0) * 100);
                            const updated = [...animalData];
                            updated[idx] = {
                              ...updated[idx],
                              commercialized_value: numericValue,
                              valorTouched: true
                            };
                            setAnimalData(updated);
                          }}
                          onBlur={() => {
                            const updated = [...animalData];
                            updated[idx] = { ...updated[idx], valorTouched: true };
                            setAnimalData(updated);
                          }}
                          error={a.valorTouched && (!a.commercialized_value || a.commercialized_value <= 0)}
                          helperText={a.valorTouched && (!a.commercialized_value || a.commercialized_value <= 0) ? 'Campo obrigatório' : ''}
                          thousandSeparator="."
                          decimalSeparator=","
                          prefix="R$ "
                          decimalScale={2}
                          fixedDecimalScale
                          allowNegative={false}
                          fullWidth
                        />
                      </Box>
                      <Box mt={2}>
                        <TextField
                          value={a.commercialized_volume ?? ''}
                          label="Volume comercializado no último ano"
                          onChange={(e) => {
                            const value = e.target.value === '' ? undefined : Number(e.target.value);
                            if (value === undefined || value >= 0) {
                              const updated = [...animalData];
                              updated[idx] = { ...updated[idx], commercialized_volume: value };
                              setAnimalData(updated);
                            }
                          }}
                          onInput={(e: any) => {
                            const target = e.target || e.currentTarget;
                            if (!target || typeof target.value !== 'string') return;
                            // Remove non-numeric characters except decimal point
                            target.value = target.value.replace(/[^\d.]/g, '');
                            // Prevent multiple decimal points
                            const decimalCount = (target.value.match(/\./g) || []).length;
                            if (decimalCount > 1) {
                              target.value = target.value.replace(/\.(?=.*\.)/g, '');
                            }
                          }}
                          fullWidth
                          inputProps={{ inputMode: 'decimal' }}
                          sx={{
                            '& input[type=number]::-webkit-outer-spin-button,& input[type=number]::-webkit-inner-spin-button': {
                              WebkitAppearance: 'none',
                              margin: 0,
                            },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          }}
                        />
                      </Box>

                      <Box mt={2}>
                        <TextField
                          select
                          label="Unidade de medida"
                          value={a.measurement_unit ?? 'KG'}
                          onChange={(e) => {
                            const updated = [...animalData];
                            updated[idx] = { ...updated[idx], measurement_unit: e.target.value };
                            setAnimalData(updated);
                          }}
                          fullWidth
                        >
                          {UNIDADES_MEDIDA.map((unidade) => (
                            <MenuItem key={unidade.value} value={unidade.value}>
                              {unidade.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Box>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <Typography variant="subtitle1" component="legend" gutterBottom>Possui registro de inspeção? *</Typography>
                        <RadioGroup
                          row
                          value={a.has_inspection_register ? 'sim' : 'nao'}
                          onChange={(e) => {
                            const has = e.target.value === 'sim';
                            setAnimalData(animalData.map(item => item.product_uuid === a.product_uuid ? { ...item, has_inspection_register: has } : item));
                          }}
                        >
                          <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                          <FormControlLabel value="nao" control={<Radio />} label="Não" />
                        </RadioGroup>
                      </FormControl>
                      {a.has_inspection_register && (
                        <Box mt={2}>
                          <Typography variant="subtitle1" gutterBottom>Selos de inspeção *</Typography>
                          {a.inspection_seals.map((selo, seloIndex) => (
                            <Box key={seloIndex} p={2} mb={2} bgcolor="#f5f5f5" borderRadius={1}>
                              <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                  <TextField label="Tipo de selo *" value={selo.inspection_seal} InputProps={{ readOnly: true }} fullWidth />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <TextField label="Número de registro *" value={selo.register_number} InputProps={{ readOnly: true }} fullWidth />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <TextField label="Data de emissão *" value={formatDateToDisplay(selo.issue_date)} InputProps={{ readOnly: true }} fullWidth />
                                </Grid>
                              </Grid>
                              <Box display="flex" justifyContent="flex-end" mt={1}>
                                <Button size="small" color="error" onClick={() => setAnimalData(animalData.map(item => item.product_uuid === a.product_uuid ? { ...item, inspection_seals: item.inspection_seals.filter((_, i) => i !== seloIndex) } : item))}>Remover</Button>
                              </Box>
                            </Box>
                          ))}
                          {!a.showSeloForm && (
                            <Button variant="outlined" onClick={() => setAnimalData(animalData.map(item => item.product_uuid === a.product_uuid ? { ...item, showSeloForm: true, dateError: false, registerNumberError: false } : item))}>Adicionar Selo</Button>
                          )}
                          {a.showSeloForm && (
                            <Box mt={2} p={2} border="1px dashed #ccc" borderRadius={1}>
                              <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                  <TextField select label="Tipo de selo *" value={novoSelo.inspection_seal} onChange={(e) => setAnimalData(animalData.map(item => item.product_uuid === a.product_uuid ? { ...item, novoSelo: { ...novoSelo, inspection_seal: e.target.value as string } } : item))} fullWidth>
                                    {selosDeInspecaoOptions.map((tipo) => (
                                      <MenuItem key={tipo.value} value={tipo.value}>{tipo.label}</MenuItem>
                                    ))}
                                  </TextField>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <TextField
                                    label="Número de registro *"
                                    placeholder="Ex: 12345/2024"
                                    value={novoSelo.register_number}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const isValid = /^[0-9/-\s]*$/.test(value);
                                      if (isValid || value === '') {
                                        setAnimalData(animalData.map(item =>
                                          item.product_uuid === a.product_uuid
                                            ? { ...item, novoSelo: { ...novoSelo, register_number: value }, registerNumberError: false }
                                            : item
                                        ));
                                      }
                                    }}
                                    error={a.registerNumberError}
                                    helperText={a.registerNumberError ? 'Número de registro inválido. Use apenas números, "/" e "-".' : undefined}
                                    fullWidth
                                  />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <TextFieldDataCustom
                                    label="Data de emissão *"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={normalizeIso(novoSelo.issue_date)}
                                    onChange={(e) => {
                                      const inputValue = e.target.value;

                                      let hasError = false;
                                      if (inputValue) {
                                        const dateParts = inputValue.split('-');
                                        if (dateParts.length === 3 && dateParts[0] && dateParts[1] && dateParts[2]) {
                                          const yearStr = dateParts[0];
                                          const monthStr = dateParts[1];
                                          const dayStr = dateParts[2];

                                          if (yearStr.length === 4 && monthStr.length === 2 && dayStr.length === 2) {
                                            const year = Number(yearStr);
                                            if (year < 1900) {
                                              hasError = true;
                                            }
                                          }
                                        }
                                      }

                                      setAnimalData(animalData.map(item =>
                                        item.product_uuid === a.product_uuid
                                          ? {
                                            ...item,
                                            novoSelo: { ...novoSelo, issue_date: inputValue },
                                            dateError: hasError
                                          }
                                          : item
                                      ));
                                    }}
                                    error={a.dateError}
                                    helperText={a.dateError ? 'Data Inválida' : undefined}
                                    fullWidth
                                  />
                                </Grid>
                              </Grid>
                              <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
                                <Button variant="outlined" onClick={() => setAnimalData(animalData.map(item => item.product_uuid === a.product_uuid ? { ...item, showSeloForm: false, novoSelo: { inspection_seal: '', register_number: '', issue_date: '' }, dateError: false, registerNumberError: false } : item))}>Cancelar</Button>
                                <Button variant="contained" onClick={() => {
                                  if (!novoSelo.inspection_seal || !novoSelo.register_number || !novoSelo.issue_date) return;
                                  if (a.dateError || a.registerNumberError) return;

                                  const dateParts = novoSelo.issue_date.split('-');
                                  if (dateParts.length === 3) {
                                    const yearStr = dateParts[0];
                                    const year = Number(yearStr);
                                    if (yearStr.length !== 4 || year < 1900) {
                                      setAnimalData(animalData.map(item =>
                                        item.product_uuid === a.product_uuid
                                          ? { ...item, dateError: true }
                                          : item
                                      ));
                                      return;
                                    }
                                  }

                                  if (!/^[0-9/-\s]+$/.test(novoSelo.register_number)) {
                                    setAnimalData(animalData.map(item =>
                                      item.product_uuid === a.product_uuid
                                        ? { ...item, registerNumberError: true }
                                        : item
                                    ));
                                    return;
                                  }

                                  setAnimalData(animalData.map(item => item.product_uuid === a.product_uuid ? { ...item, inspection_seals: [...item.inspection_seals, novoSelo], showSeloForm: false, novoSelo: { inspection_seal: '', register_number: '', issue_date: '' }, dateError: false, registerNumberError: false } : item));
                                }} disabled={!novoSelo.inspection_seal || !novoSelo.register_number || !novoSelo.issue_date || a.dateError || a.registerNumberError}>Adicionar</Button>
                              </Box>
                            </Box>
                          )}
                        </Box>
                      )}
                    </Box>
                  );
                })}
              </Paper>
            )}

            <Box marginTop="2rem" display="flex" justifyContent="center" gap="1rem">
              <Button variant="outlined" color="secondary" onClick={() => navigate(ROUTES.PRODUTOS_PROCESSADOS_INCLUIR.replace(':uuid', uuid ?? ''))} disabled={saving}>Retornar</Button>
              <Button variant="outlined" color="secondary" onClick={handleSave} disabled={saving}>
                {saving && !advanceNext.current ? <CircularProgress size={24} color="inherit" /> : 'Salvar'}
              </Button>
              <Button variant="contained" color="primary" onClick={handleAdvance} disabled={saving}>
                {saving && advanceNext.current ? <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} /> : null}
                Avançar
              </Button>
            </Box>
          </ContainerForm>
        </Box>
      </Box>

      <Snackbar open={openSuccessSnackbar} autoHideDuration={3000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}><Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>{snackbarMessage}</Alert></Snackbar>
      <Snackbar open={openErrorSnackbar} autoHideDuration={4000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}><Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>{snackbarMessage}</Alert></Snackbar>
    </MenuProvider>
  );
};

export default InspecaoProdutosIncluir;
